<template>
  <v-dialog max-width="350px" v-model="dialog" @keydown.enter.prevent="close">
    <v-card>
      <v-card-title/>
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <r-item-kind-dropdown :model.sync="value.kind"/>
          </v-col>
          <v-col cols="12">
            <v-select
              label="Level:"
              v-model="value.level"
              :items="levels"
              :menu-props="{ maxHeight: '200px' }"
              hide-details
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" text @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
    <template v-slot:activator="{ on }">
      <v-text-field
        v-if="readonly"
        v-model.trim="text"
        :label="label"
        readonly
        hide-details
      />
      <v-text-field
        v-else
        v-model.trim="text"
        :label="label"
        readonly
        v-on="on"
        hide-details
        clearable
        @click:clear="clear"
      />

    </template>
  </v-dialog>
</template>

<script>
import VueTypes from "vue-types";
import {ItemKey} from "@/modules/redactor/models/item/core/ItemKey";
import RItemKindDropdown from "@/modules/redactor/views/item-kind/r-item-kind-dropdown.vue";

export default {
  name: "VItemKey",
  components: {RItemKindDropdown},
  props: {
    model: VueTypes.instanceOf(ItemKey),
    skipNone: VueTypes.bool.def(false),
    label: VueTypes.string.def("ItemKey"),
    readonly: VueTypes.bool.def(false)
  },
  data: () => ({
    dialog: false,
    text: null,
    levels: []
  }),
  methods: {
    checkChange() {
      if (this.value.kind) {
        this.text = this.value.string;
      } else {
        this.text = null;
      }
    },
    close() {
      if (this.model.empty() || this.model.valid()) {
        this.dialog = false;
      }
    },
    clear() {
      this.$emit("update:model", null);
    },

    updateLevels() {
      if (this.value?.kind?.levels?.length) {
        const baseLvls = [...this.value.kind.levels];

        if (!baseLvls.includes(100)) {
          baseLvls.push(100);
        }

        this.levels = baseLvls;
      } else {
        this.levels = [100];
      }
    }
  },
  computed: {
    value() {
      if (this.model) {
        return this.model;
      } else {
        let value = new ItemKey();
        this.$emit("update:model", value);
        return value;
      }
    }
  },
  mounted() {
    this.checkChange();
  },
  watch: {
    dialog() {
      this.checkChange();
    },

    value() {
      this.checkChange();
    },

    'value.kind': {
      handler() {
        this.updateLevels();
      },
      immediate: true
    }
  }
}
</script>